import { render, staticRenderFns } from "./announcementBanner.vue?vue&type=template&id=62f21781"
import script from "./announcementBanner.vue?vue&type=script&lang=js"
export * from "./announcementBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\web\\rcms\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62f21781')) {
      api.createRecord('62f21781', component.options)
    } else {
      api.reload('62f21781', component.options)
    }
    module.hot.accept("./announcementBanner.vue?vue&type=template&id=62f21781", function () {
      api.rerender('62f21781', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/announcements/announcementBanner.vue"
export default component.exports